import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { computeCosts } from "@/utils/costUtil";

export default function SubmitButton ({ label, loading, editId, images = [], videos = [], pricing, isFeatured,
																				featuredPaid, includedImages, includedVideos, waivedWithdrawalRight }) {

	const { t } = useTranslation();
	const cost = computeCosts(images, videos, pricing, isFeatured, featuredPaid, includedImages, includedVideos);
	const state = loading || (cost.total > 0 && !waivedWithdrawalRight);

	return (
		<Button data-testid="submit-horse-ad" type="submit" disabled={ state }
						className="w-full bg-[#1A3C34] hover:bg-[#153029] text-white rounded-sm h-14 text-base font-medium btn-equi">
			{loading ? t('common.loading') : editId ? t('common.save') : t(label)}
		</Button>
	)
}